import React, { useState, useEffect } from 'react';
import { Modal, Box, Button, TextField } from '@mui/material';
import ApiService from "./../../services/api-service";

const VideoEdit = ({ open, handleClose, item, studioId, type = "video" }) => {
  const initialThumbnail = type === "video" ? item?.thumbnail?.url : item?.thumbnailImg || "";
  const [title, setTitle] = useState(item?.title || "");
  const [description, setDescription] = useState(item?.description || "");
  const [thumbnailFile, setThumbnailFile] = useState(null);
  const [thumbnailPreview, setThumbnailPreview] = useState(initialThumbnail);

  useEffect(() => {
    if (item) {
      setTitle(item.title || "");
      setDescription(item.description || "");
      setThumbnailPreview(initialThumbnail);
    }
  }, [item, type]);

  const handleThumbnailChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setThumbnailFile(file);
      setThumbnailPreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!item?._id || !studioId) {
      console.error("Item ID or Studio ID is missing!");
      return;
    }
  
    try {
      const updatedData = new FormData();
      updatedData.append("title", title);
      updatedData.append("description", description);

      if (thumbnailFile) {
        updatedData.append("thumbnailImg", thumbnailFile);
      }
  
      const response = type === "video"
        ? await ApiService.UPDATEVIDEO({ studioId, videoId: item._id, formData: updatedData })
        : await ApiService.updateRecording(item._id, updatedData);
  
      if (response && response.status === 'success' && response.code === 200) {
        console.log("Changes saved successfully.");
        handleClose();
      } else {
        console.error("Failed to update item. Response data:", response);
      }
    } catch (error) {
      console.error("Error caught during update:", error);
    }
  };
  


  const handleDelete = async () => {
    if (!item?._id || !studioId) {
      console.error("Item ID or Studio ID is missing!");
      return;
    }

    try {
      const response = type === "video"
        ? await ApiService.deleteUserVideo(studioId, item._id)
        : await ApiService.deleteRecording(item._id);

      if (response && response.status === 'success') {
        console.log(`${type} deleted successfully.`);
        handleClose();
      } else {
        console.error(`Failed to delete ${type}. Response data:`, response);
      }
    } catch (error) {
      console.error(`Error caught during delete ${type}:`, error);
    }
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          width: 400,
          padding: 4,
          margin: '100px auto',
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          backdropFilter: 'blur(10px)',
          borderRadius: '16px',
          color: 'white',
          boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
        }}
      >
        <h2>Edit {type.charAt(0).toUpperCase() + type.slice(1)}</h2>
        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            margin="normal"
            label={`${type.charAt(0).toUpperCase() + type.slice(1)} Title`}
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            InputProps={{ style: { color: 'white' } }}
            InputLabelProps={{ style: { color: 'white' } }}
          />

          <TextField
            fullWidth
            multiline
            minRows={2}
            maxRows={6}
            margin="normal"
            label="Description"
            placeholder="Add a description…"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            inputProps={{ maxLength: 2000 }}
            InputProps={{ style: { color: 'white' } }}
            InputLabelProps={{ style: { color: 'white' } }}
          />

          <input
            type="file" 
            accept="image/*" 
            onChange={handleThumbnailChange} 
            style={{ display: 'block', margin: '20px 0', color: 'white' }} 
          />
          
          {thumbnailPreview && (
            <img 
              src={thumbnailPreview} 
              alt="Thumbnail Preview" 
              style={{ width: '100%', borderRadius: '8px', marginBottom: '20px' }} 
            />
          )}

          <Button type="submit" variant="contained" color="primary" fullWidth>
            Save Changes
          </Button>
        </form>

        <Button 
          onClick={handleDelete} 
          variant="contained" 
          color="secondary" 
          fullWidth
          style={{ marginTop: '20px' }}
        >
          Delete {type.charAt(0).toUpperCase() + type.slice(1)}
        </Button>
      </Box>
    </Modal>
  );
};

export default VideoEdit;
